import type { TFunction } from 'i18next';
import { errorToastMessage } from '../../components/layout/toast-root/toast';
import { getResetPasswordFormValidation } from './FormikData';
import { FirebaseErrorCodes } from '../../shared/constants';
import { useFormik } from 'formik';
import { useFirebaseAuth } from '../../hooks/useFirebaseAuth';

export function useResetPasswordPage(
  t: TFunction,
  oobCode: string,
  afterResetPassword: () => void,
) {
  const { confirmPasswordReset } = useFirebaseAuth();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getResetPasswordFormValidation(t),
    initialValues: { password: '', confirmPassword: '' },
    onSubmit: submit,
  });

  async function submit(values: { password: string }) {
    try {
      if (oobCode) {
        await confirmPasswordReset(oobCode, values.password);

        afterResetPassword();
      } else {
        errorToastMessage(t('resetPassword.errorResetPasswordMessage'));
      }
    } catch (error: any) {
      console.error('Register error message: ', error);
      if (FirebaseErrorCodes.includes(error.code)) {
        errorToastMessage(t(`error.${error.code}`));

        return;
      }
      errorToastMessage(t('error.somethingWentWrong'));
    }
  }

  return { formik };
}
